module.exports = __webpack_public_path__ + "static/media/more.287bfd45.png";